<template>
<div>
<!-- <app-header></app-header> -->
<div class="l-container">
    <div class="visual-area">
        <div class="circle-area">
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
        </div>
        <strong class="tit">Our Business</strong>
        We have a variety of business models to create new services.<br>Our commitment to our customers will continue.
    </div>
    <ul class="scope-of-works">
        <li class="consult">
            <strong>Consulting</strong>
            고객의 비즈니스 목적에 맞는 <br>
            분석과 전략으로 최적의 서비스를 <br> 
            제공합니다.
        </li>
        <li class="design">
            <strong>UI/UX Design</strong>
            다양한 사용자에게 확장될 수 있는<br>
            쉽고 안정적인 UI/UX 디자인<br>
            환경을 만들어 갑니다.
        </li>
        <li class="developement">
            <strong>Development</strong>
            다양한 플랫폼과 새로운 기술에 대한<br>
            지속적인 경험으로 빠르게 변화하는 <br>
            환경에 유연하게 대응합니다.
        </li>
        <li class="marketing">
            <strong>Marketing</strong>
            고객에게 최적화된 마케팅 전략은<br>
            새로운 브랜드로의 소통이<br>
            가능 할 수 있도록 지원합니다.
        </li>
    </ul>
    <div class="partner-list">
        <strong class="tit">Partners</strong>
        <ul>
            <li v-for="(partner, index) in store.partners" :key="index"><img v-lazy="partner.imgsrc" :alt="partner.imgalt"></li>
        </ul>
        <button class="btn-more-partner"><span class="a11y-hidden">파트너 더보기</span></button>
    </div>
</div>
<!-- <app-footer></app-footer> -->
</div>
</template>

<script>
// import Header from './Header.vue';
// import Footer from './Footer.vue';
import {store} from '../data/store.js';   
export default {
   data(){
       return{
           store
       }
   },
//    components: {
//        'app-header': Header,
//        'app-footer': Footer
//    },
   mounted:function(){
       var num = 0;
       var $partnerList = $('.partner-list li');
       var size = parseInt($partnerList.length);
       //$partnerList.hide();
       
       $('.btn-more-partner').on('click',function(){                      
           $partnerList.each(function(i){
               if(i < 12){
                   $partnerList.eq(i).show();                   
               }
               num++;
           });
       });

        var st = $(window).scrollTop();
        var winH = $(window).outerHeight();
        $(window).on('scroll',function(){
            st = $(this).scrollTop();
            $('.partner-list').find('li').each(function(){
                var top = $(this).offset().top;
                if(st >= top - winH) $(this).addClass('is-view');
            });
        });
        
      
       
   },
   created () {
    console.log('xgAboutus')
  }
}
</script>


// WEBPACK FOOTER //
// src/components/XgAboutus.vue